import {Box, Button, Stack, Typography} from "@mui/material";
import {apiGetTicketInfo} from "@/modules/tickets/services/tickets.service";
import {TicketStatus, TicketsTypes} from "@/modules/tickets";
import {getName} from "@/global/helpers/text";
import {FileOpenOutlined} from "@mui/icons-material";
import {useModal} from "@/global/providers/ModalProvider";
import {TicketReject} from "@/modules/tickets/pages/info/components/TicketReject/TicketReject";
import {toast} from "react-toastify";
import {TicketSend} from "@/modules/tickets/pages/info/components";
import {ticketDtoStatusEnum} from "@/global/api/gen/ts/TicketDto";
import {useParams} from "react-router-dom";
import {TicketField} from "./TicketField";
import {useMemo} from "react";
import {useUserStore} from "@/global/store/UserStore";
import {convertBase64ToFile} from "@/global/helpers/convertFileToBase64";

export function TicketInfoMain() {
    const {id} = useParams();
    const {data} = apiGetTicketInfo(+(id ?? 0));
    const ticketStatus = data?.status ? TicketStatus[data?.status] : null;

    const {openModal} = useModal();

    const isAdmin = useUserStore((state) => state.isAdmin || state.isSuperAdmin);

    const historyText = useMemo(() => {
        if (data?.status === ticketDtoStatusEnum['20']) {
            return `Отклонено по причине: ${data.messages.at(-1)?.message}`;
        }
        if (data?.incoming_id) {
            return (
                <>
                    <Typography component={'div'}>
                        Перенаправлено в МВД
                    </Typography>
                    {data?.messages.at(-1)?.data.history?.log.map((el, index) => (
                        <Typography
                            component={'div'}
                            key={index}
                        >
                            {el.message}
                        </Typography>
                    ))}
                </>
            );
        }
        return '';
    }, [data]);

    const files = useMemo(() => {
        if (!data || data.messages.length === 0) {
            return [];
        }
        return data.messages.at(0)?.files_urls?.map((el) => {
            return convertBase64ToFile(el);
        }) ?? [];
    }, [data]);

    const onOpenReject = () => {
        if (!data) {
            toast.error('Ошибка при загрузке тикета. Обновите страницу и повторите позже');
            return;
        }
        openModal(TicketReject, {ticketId: data.id});
    };

    const onOpenSend = () => {
        if (!data) {
            toast.error('Ошибка при загрузке тикета. Обновите страницу и повторите позже');
            return;
        }
        openModal(TicketSend, {ticketId: data.id});
    };

    return (
        <Stack gap={8}>
            <Stack
                flexDirection={'row'}
                alignItems={'center'}
                gap={5}
            >
                <Typography
                    fontSize={30}
                    color={'#05304F'}
                >
                    Тикет
                    {' '}
                    {data?.id}
                </Typography>
                <Stack
                    flexDirection={'row'}
                    alignItems={'center'}
                    gap={2}
                >
                    <Box
                        sx={{
                            border: '1px solid #05304F',
                            padding: '4px 20px',
                            borderRadius: '50px',
                        }}
                    >
                        Статус
                    </Box>
                    <Typography>
                        {ticketStatus?.label ?? ''}
                    </Typography>
                </Stack>
            </Stack>
            <Stack
                sx={{
                    backgroundColor: 'white',
                    paddingTop: 4,
                    borderRadius: '20px',
                }}
            >
                <Stack>
                    <TicketField
                        label="ВХОДЯЩИЙ НОМЕР"
                        value={data?.incoming_id}
                    />
                    <TicketField
                        label="ТЕМА"
                        value={(data?.title && data?.title in TicketsTypes) ? TicketsTypes[data?.title as keyof typeof TicketsTypes] : data?.title}
                    />
                    <TicketField
                        label="ШКОЛА"
                        value={data?.school?.title}
                    />
                    <TicketField
                        label="ПОЛЬЗОВАТЕЛЬ"
                        value={data?.user ? getName(data?.user).fullName: 'Не указано'}
                    />
                    <TicketField
                        label="ОБРАЩЕНИЕ"
                        value={data?.messages.at(0)?.message}
                    />
                    <TicketField
                        label="ПРИКРЕПЛЕННЫЕ ФАЙЛЫ"
                        value={(
                            <Stack
                                flexDirection={'row'}
                                gap={2}
                            >
                                {files.map((el, index) => (
                                    <a
                                        key={index}
                                        href={el}
                                        target={`_blank`}
                                    >
                                        <FileOpenOutlined
                                            sx={{
                                                fontSize: '30px',
                                            }}
                                        />
                                    </a>
                                ))}
                            </Stack>
                        )}
                    />
                    <TicketField
                        label="ИСТОРИЯ"
                        value={historyText}
                    />
                    <TicketField
                        label="ОТВЕТСТВЕННЫЙ СОТРУДНИК"
                        value={data?.manager ? getName(data.manager).fullName : ''}
                    />
                </Stack>
                {
                    (data && isAdmin && !data.incoming_id && data.status !== ticketDtoStatusEnum["20"]) && (
                        <Stack
                            flexDirection={'row'}
                            alignItems={'center'}
                            flexWrap={'wrap'}
                            gap={4}
                            sx={{
                                padding: 2,
                            }}
                        >
                            <Button
                                onClick={onOpenReject}
                                color={'error'}
                                variant={'contained'}
                                sx={{
                                    minWidth: '200px'
                                }}
                            >
                                Отклонить
                            </Button>
                            <Button
                                variant={'contained'}
                                onClick={onOpenSend}
                                sx={{
                                    minWidth: '200px'
                                }}
                            >
                                Перенаправить
                            </Button>
                        </Stack>
                    )}
            </Stack>
        </Stack>
    );
}